import $ from "jquery";

let selectedFilters = [];
let selectedFiltersDiv = $(".selected-filters-filters");
let postsPerPage = 9; // Initially show 9 posts
let increment = 6; // Show 6 more posts on each load more click

function updateLoadMoreButton() {
  let visibleCards = $(".case-studies-card:visible").length;
  let totalFilteredCards = 0;

  // Count total cards that match current filter
  if (selectedFilters.length === 0) {
    totalFilteredCards = $(".case-studies-card").length;
  } else {
    $(".case-studies-card").each(function () {
      let categories = $(this).find(".category").text().trim();
      if (selectedFilters.some((filter) => categories.includes(filter))) {
        totalFilteredCards++;
      }
    });
  }

  // Show or hide the load more button based on whether there are more posts to show
  if (visibleCards < totalFilteredCards) {
    $(".load-more").show();
  } else {
    $(".load-more").hide();
  }
}

function updateProjectCards() {
  if (selectedFilters.length === 0) {
    // Show first 9 cards by default
    $(".case-studies-card").removeClass("show");
    $(".case-studies-card").hide();
    $(".case-studies-card").slice(0, postsPerPage).addClass("show").show();

    selectedFiltersDiv
      .empty()
      .append('<div class="no-filter-selected">None Selected</div>');
  } else {
    $(".no-filter-selected").remove();
    let shownCount = 0;

    // Reset all cards
    $(".case-studies-card").removeClass("show").hide();

    // Filter and show cards based on selected categories
    $(".case-studies-card").each(function () {
      let categories = $(this).find(".category").text().trim();
      let matchesFilter = selectedFilters.some((filter) =>
        categories.includes(filter)
      );

      if (matchesFilter && shownCount < postsPerPage) {
        $(this).addClass("show").show();
        shownCount++;
      }
    });
  }

  updateLoadMoreButton();
}

function updateSelectedFilters() {
  selectedFiltersDiv.empty();
  if (selectedFilters.length === 0) {
    selectedFiltersDiv.append(
      '<div class="no-filter-selected">None Selected</div>'
    );
  } else {
    selectedFilters.forEach((filter) => {
      selectedFiltersDiv.append(
        '<div class="selected-filter">' + filter + "</div>"
      );
    });
  }
}

// Load more handler
$(".load-more").on("click", function () {
  let visibleCards = $(".case-studies-card:visible").length;
  let nextBatch = visibleCards + increment;

  if (selectedFilters.length === 0) {
    // If no filters, just show the next batch of cards
    $(".case-studies-card").slice(0, nextBatch).addClass("show").show();
  } else {
    // If filters are selected, only show cards that match the filters
    let shownCount = 0;
    $(".case-studies-card").each(function () {
      let categories = $(this).find(".category").text().trim();
      let matchesFilter = selectedFilters.some((filter) =>
        categories.includes(filter)
      );

      if (matchesFilter) {
        shownCount++;
        if (shownCount <= nextBatch) {
          $(this).addClass("show").show();
        }
      }
    });
  }

  updateLoadMoreButton();
});

// Existing filter click handlers
$(".filter-box_option").on("click", function () {
  let filterValue = $(this).text().trim();
  let $filterBox = $(this).closest(".filter-box");
  let $allOption = $filterBox.find(".filter-box_option-all");

  if (selectedFilters.includes(filterValue)) {
    selectedFilters = selectedFilters.filter(
      (filter) => filter !== filterValue
    );
    $(this).removeClass("selected");
  } else {
    selectedFilters.push(filterValue);
    $(this).addClass("selected");
  }

  if (selectedFilters.length === 0) {
    $allOption.addClass("selected");
  } else {
    $allOption.removeClass("selected");
  }

  // Reset post count when changing filters
  postsPerPage = 9;
  updateSelectedFilters();
  updateProjectCards();
});

$(".filter-box_option-all").on("click", function () {
  let $filterBox = $(this).closest(".filter-box");
  $(this).addClass("selected");
  $filterBox.find(".filter-box_option").removeClass("selected");
  selectedFilters = [];

  // Reset post count when changing to all
  postsPerPage = 9;
  updateSelectedFilters();
  updateProjectCards();
});

$(".selected-filters-clear").on("click", function () {
  selectedFilters = [];
  $(".filter-box_option").removeClass("selected");
  $(".filter-box_option-all").addClass("selected");

  // Reset post count when clearing filters
  postsPerPage = 9;
  updateSelectedFilters();
  updateProjectCards();
});

$(".selected-filters-filters").on("click", ".selected-filter", function () {
  let filterValue = $(this).text().trim();
  selectedFilters = selectedFilters.filter((filter) => filter !== filterValue);
  $('.filter-box_option:contains("' + filterValue + '")').removeClass(
    "selected"
  );

  if (selectedFilters.length === 0) {
    $(".filter-box_option-all").addClass("selected");
  }

  // Reset post count when removing a filter
  postsPerPage = 9;
  updateSelectedFilters();
  updateProjectCards();
});

$(".filter-box_title").on("click", function () {
  $(this).toggleClass('opened')
  $(this).siblings(".filter-box_options").slideToggle("slow");
  $(this).find("svg").toggleClass("rotate-arrow");
});

// Initialize on page load
$(document).ready(function () {
  // Hide all cards initially
  $(".filter-case-studies-container .case-studies-card").hide();

  // Show initial set of cards
  $(".filter-case-studies-container .case-studies-card.show").show();

  // Update load more button
  updateLoadMoreButton();
});
